// extracted by mini-css-extract-plugin
export default {"ProfileMenu":"ProfileMenu_ProfileMenu__Nm9T7","ProfileMenuAvatar":"ProfileMenu_ProfileMenuAvatar__bTZbS","ProfileMenuInfo":"ProfileMenu_ProfileMenuInfo__vLQop"};